module.exports = __webpack_public_path__ + "img/stock-image-office.855b9ef0.jpeg";